const languages = [
	{
		slug: 'tr',
		label: 'Türkçe',
		flag: '🇹🇷',
	},
	{
		slug: 'en',
		label: 'English',
		flag: '🇬🇧',
	},
];

export const getLanguage = (slug) => languages.find((l) => l.slug === slug) ?? null;

export default languages;
